package ui.home.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.dp
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import ui.home.NavSidebarItem
import ui.home.getNavSidebarItems

@Composable
fun NavSidebar(
    selectedItem: NavSidebarItem,
    onItemSelected: (NavSidebarItem) -> Unit,
    getProfile: State<ProfileModel>,
    logout: () -> Unit,
    badgeCounts: Map<NavSidebarItem, Int>,
    modifier: Modifier = Modifier,
) {
    val lazyListState = rememberLazyListState()

    Column(
        verticalArrangement = Arrangement.SpaceBetween,
        modifier = Modifier
            .width(80.dp)
            .fillMaxHeight(),
    ) {
        Box(
            modifier = Modifier
                .clip(RoundedCornerShape(2.spacing))
                .fillMaxWidth()
                .weight(1f),
        ) {
            LazyColumn(
                horizontalAlignment = Alignment.CenterHorizontally,
                state = lazyListState,
                modifier = modifier
                    .fillMaxSize()
                    .background(MaterialTheme.esColorScheme.bgPrimary),
            ) {
                item {
                    Spacer(modifier = Modifier.height(.5f.spacing))
                }

                items(getNavSidebarItems()) { item ->

                    val badgeCount = badgeCounts[item] ?: 0

                    NavSidebarIconButton(
                        onClick = { onItemSelected(item) },
                        item = item,
                        badgeCount = badgeCount,
                        isSelected = selectedItem == item,
                        modifier = Modifier.padding(horizontal = 16.dp),
                    )

                    Spacer(modifier = Modifier.height(2.spacing))
                }
            }

            Box(
                modifier = Modifier
                    .graphicsLayer {
                        alpha =
                            if (lazyListState.canScrollBackward)
                                1f
                            else
                                0f
                    }
                    .align(Alignment.TopCenter)
                    .fillMaxWidth()
                    .height(10.dp)
                    .background(
                        brush = Brush.verticalGradient(
                            colors = listOf(
                                MaterialTheme.esColorScheme.primary.copy(alpha = .2f),
                                Color.Transparent,
                            ),
                        ),
                    ),
            )

            Box(
                modifier = Modifier
                    .graphicsLayer {
                        alpha =
                            if (lazyListState.canScrollForward)
                                1f
                            else
                                0f
                    }
                    .align(Alignment.BottomCenter)
                    .fillMaxWidth()
                    .height(10.dp)
                    .background(
                        brush = Brush.verticalGradient(
                            colors = listOf(
                                Color.Transparent,
                                MaterialTheme.esColorScheme.primary.copy(alpha = .2f),
                            ),
                        ),
                    ),
            )
        }

        Spacer(
            modifier = Modifier
                .height(10.dp),
        )

        NavSidebarProfile(
            getProfile = getProfile,
            logout = logout,
            modifier = Modifier
                .fillMaxWidth()
                .align(Alignment.CenterHorizontally),
        )
    }
}